import Crud from '../components/Category/Crud'
import Entity from '../components/Category/Add'

let routes = {
    path: '/categories',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        // {
        //     path: '/categories/add',
        //     name: 'Nova Categoria',
        //     component: Entity
        // },
        {
            path: '/categories',
            name: 'Gerenciar Checklists',
            component: Entity
        },
        // {
        //     path: '/categories',
        //     name: 'Editar Categoria',
        //     component: Entity
        // },
    ]
};


export default routes



// WEBPACK FOOTER //
// ./src/router/category.js